import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { Map } from "immutable";
import { Detail, DetailTable, ExternalLink } from "MODULES/shared/components";
import { CLASSIFIED_MEMO, IMPORTANT_MEMO } from "MODULES/parts/constants";
import AuditedNoteTooltip from "MODULES/shared/components/NoteTooltip/AuditedNoteTooltip";
import { Detail as TableRowDetail } from "MODULES/shared/components/DetailTable";
import { COMPANY_TYPES, WEBSITE } from "../../constants";

export default function DetailsTable({ company }) {
  return (
    <div>
      <DetailTable>
        <Detail
          label="Type"
          value={
            company.get("company_type") &&
            COMPANY_TYPES[company.get("company_type")].label
          }
        />
        <Detail label="Cage" value={company.get("cage")} />
        <Detail label="Phone" value={company.get("phone")} />
        <Detail label="fax" value={company.get("fax")} />
        <Detail
          label="Website"
          value={<ExternalLink url={company.get(WEBSITE)} />}
        />
        <TableRowDetail
          label="Imp Memo"
          value={
            company.get(IMPORTANT_MEMO) && (
              <Fragment>
                <span style={{ color: "#F44336" }}>
                  {company.get(IMPORTANT_MEMO)}
                </span>{" "}
                {company.get(`${IMPORTANT_MEMO}_audit`) && (
                  <AuditedNoteTooltip
                    obj={company.toJS()}
                    field={IMPORTANT_MEMO}
                  />
                )}
              </Fragment>
            )
          }
          renderIfPresent
        />
        <TableRowDetail
          label="Clsfd Memo"
          value={
            company.get(CLASSIFIED_MEMO) && (
              <Fragment>
                {company.get(CLASSIFIED_MEMO)}{" "}
                {company.get(`${CLASSIFIED_MEMO}_audit`) && (
                  <AuditedNoteTooltip
                    obj={company.toJS()}
                    field={CLASSIFIED_MEMO}
                  />
                )}
              </Fragment>
            )
          }
          renderIfPresent
        />
      </DetailTable>
    </div>
  );
}

DetailsTable.propTypes = {
  company: PropTypes.instanceOf(Map)
};



// WEBPACK FOOTER //
// ./app/modules/companies/components/Detail/DetailsTable.jsx